import actions from './actions'

const initialState = {
  costCenters: [],
  loading: false,
  ready: false,
}

export default function costCentersReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
